import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=b9598bd0&"
import script from "./order-card.vue?vue&type=script&lang=ts&"
export * from "./order-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports